type Props = {
  page: number;
  pageSize: number;
  total: number;
  onChange: (page: number) => void;
};

function pageNumbers(current: number, total: number): Array<number | 'ellipsis'> {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: Array<number | 'ellipsis'> = [1];
  const start = Math.max(2, current - 2);
  const end = Math.min(total - 1, current + 2);
  if (start > 2) pages.push('ellipsis');
  for (let p = start; p <= end; p++) pages.push(p);
  if (end < total - 1) pages.push('ellipsis');
  pages.push(total);
  return pages;
}

export function Pagination({ page, pageSize, total, onChange }: Props) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const safe = Math.min(Math.max(page, 1), totalPages);
  const items = pageNumbers(safe, totalPages);
  const from = (safe - 1) * pageSize + 1;
  const to = Math.min(safe * pageSize, total);

  return (
    <nav className="pagination" aria-label="Paginación">
      <span className="pagination-info">
        {from}–{to} de {total}
      </span>
      <div className="pagination-buttons">
        <button
          type="button"
          className="pagination-btn"
          onClick={() => onChange(safe - 1)}
          disabled={safe <= 1}
          aria-label="Página anterior"
        >
          ‹
        </button>
        {items.map((it, idx) =>
          it === 'ellipsis' ? (
            <span key={`e-${idx}`} className="pagination-ellipsis">…</span>
          ) : (
            <button
              key={it}
              type="button"
              className={`pagination-btn ${it === safe ? 'pagination-btn-active' : ''}`}
              onClick={() => onChange(it)}
              aria-current={it === safe ? 'page' : undefined}
            >
              {it}
            </button>
          ),
        )}
        <button
          type="button"
          className="pagination-btn"
          onClick={() => onChange(safe + 1)}
          disabled={safe >= totalPages}
          aria-label="Página siguiente"
        >
          ›
        </button>
      </div>
    </nav>
  );
}
